import { validateInputs } from "shared/utils/Utils";
import style from "./BrandRegistration.module.css";
import { requester } from "App";
import Container from "layouts/container/Container";
import Center from "layouts/wrapper/Center";
import P from "components/P";
import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import InputText from "components/inputs/signUp/InputText";
import { useEffect, useRef, useState } from "react";
import { textFormat } from "InitialData/regExp";
import { toast } from "react-toastify";
import CustomButton from "components/buttons/CustomButton";
import InputImage from "components/inputs/image/InputImage";
import { CFormSelect } from "@coreui/react";
import { useLocation } from "react-router-dom";

function BrandListDetail(props) {
    const inputs = useRef([]);
    const location = useLocation();
    const [brand, setBrand] = useState();
    const [selectedType, setSelectedType] = useState(brand ? brand.brandType : "");

     // brand가 변경될 때 selectedType도 업데이트
     useEffect(() => {
        if (location && location.state && location.state.data) {
            const data = location.state.data;
            setBrand(data);
            setSelectedType(data.brandType);  // brandType 값을 상태로 설정
        }
    }, [location]);

    const onClick = () => {
        let data = {
            id: brand && brand.id,
            brandName: "",
            contents: "",
            brandImg: "",
            brandType: selectedType ? selectedType : ""

        }

        validateInputs(inputs.current).then((result) => {

            if (result.isValid) {
                data.brandName = inputs.current[0].getValue();
                data.contents = inputs.current[1].getValue();
                data.brandImg = inputs.current[2].getValue();

                requester.updateBrand(data, (result) => {
                    if (result.code === 0) {

                        toast.success(`브랜드수정이 완료되었습니다`, {
                            autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                        });
                    }
                });

            } else {
                toast.error(`${inputs.current[result.index].getName()} 항목을 확인해주세요`, {
                    autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                });
            }


        });

    }
    const handleSelectChange = (event) => {
        // 여기에서 선택된 카테고리의 ID를 사용할 수 있습니다.

        setSelectedType(event.target.value);
    };
    const btnStyle = {
        backgroundColor: "var(--main-color)",
        border: "none"
    }
    return (
        <Container>
            <Container maxWidth={1200}>
                <Center width={"100%"} textAlign={"left"}>
                    <P size={40} font={"gmarketSansBold"}>브랜드 정보수정</P>
                </Center>
                <VerticalFlex flexStart padding={"30px"} gap={20}>

                    <FlexChild>
                        <HorizontalFlex gap={30}>
                            <FlexChild width={"20%"} >
                                <P>브랜드명 : </P>
                            </FlexChild>
                            <FlexChild>
                                <InputText ref={el => (inputs.current[0] = el)} placeHolder={"브랜드명"} regExp={[textFormat]} value={brand && brand.brandName} />
                            </FlexChild>
                        </HorizontalFlex>

                    </FlexChild>
                    <FlexChild>
                        <HorizontalFlex gap={30}>
                            <FlexChild width={"20%"} >
                                <P>설명 : </P>
                            </FlexChild>
                            <FlexChild>
                                <InputText ref={el => (inputs.current[1] = el)} placeHolder={"설명"} regExp={[textFormat]} value={brand && brand.contents} />
                            </FlexChild>
                        </HorizontalFlex>

                    </FlexChild>
                    <FlexChild>
                        <HorizontalFlex gap={30}>
                            <FlexChild width={"20%"} >
                                <P>브랜드 타입 : </P>
                            </FlexChild>
                            <FlexChild>
                                <CFormSelect onChange={handleSelectChange} value={selectedType}>
                                    <option value={""}>선택하세요</option>
                                    <option value={"LIQUID"}>
                                        액상
                                    </option>
                                    <option value={"DEVICE"}>
                                        기기
                                    </option>
                                    <option value={"DISPOSABLEDEVICE"}>
                                        일회용
                                    </option>
                                </CFormSelect>
                            </FlexChild>
                        </HorizontalFlex>

                    </FlexChild>
                    <FlexChild>
                        <HorizontalFlex gap={30}>
                            <FlexChild width={"20%"} >
                                <P>브랜드 이미지 : </P>
                            </FlexChild>
                            <FlexChild>
                                <InputImage ref={el => (inputs.current[2] = el)} name={"브랜드 이미지"} value={brand && brand.brandImg} path={"brand/"} labelWidth={0} cropWidth={750} cropHeight={370} maxSizeMb={1} />
                            </FlexChild>
                        </HorizontalFlex>
                    </FlexChild>
                    {/* <FlexChild>
                        <HorizontalFlex gap={30}>
                            <FlexChild width={"20%"} >
                                <P>상품가격 : </P>
                            </FlexChild>
                            <FlexChild>
                                <InputText ref={el => (inputs.current[1] = el)} placeHolder={"상품가격"} regExp={[textFormat]} />
                            </FlexChild>

                        </HorizontalFlex>

                    </FlexChild> */}

                    <FlexChild>
                        <CustomButton style={btnStyle} text={"수정"} onClick={onClick} />
                    </FlexChild>
                </VerticalFlex>
            </Container>
        </Container >
    )
}

export default BrandListDetail;